"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.find = exports.register = void 0;
var diveAiState_sidecar_1 = require("@dive/ai/diveAiState-sidecar");
var enumsAi_1 = require("@dive/ai/enumsAi");
var diveColors_1 = require("@dive/colors/diveColors");
var diveSlashEffect_1 = require("@dive/effects/diveSlashEffect");
var diveEnums_1 = require("@dive/enums/diveEnums");
var imports_1 = require("@lib/imports");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var diveCrew_weaponData_sidecar_1 = require("./diveCrew_weaponData-sidecar");
var _default = {
    type: 'default',
    name: 'Default',
    letter: '',
    frames: {
        idle: sprites_sidecar_1.sprites.diveEffectsCloud3,
        dead: sprites_sidecar_1.sprites.diveEffectsCloud3,
        attackR: sprites_sidecar_1.sprites.diveEffectsCloud3,
    },
    splatterTint: diveColors_1.diveColors.red,
    splatterType: diveEnums_1.EDiveSplatterType.Blood,
    weaponData: diveCrew_weaponData_sidecar_1.diveCrew_weaponData.createData({}),
    initialAi: diveAiState_sidecar_1.diveAiState.create(),
    maxHitpoints: 100,
    moveTime: 5,
    renderShadow: 0,
    scale: 1,
    transformInto: '',
    transformTicksTime: 0,
    abilities: [],
    maxAbilityTicksTime: 10,
    resistances: {},
    onHitEffect: enumsAi_1.EDiveOnHitEffect.None,
};
var _dataList = [];
function register(data) {
    var d = Object.assign({}, _default, data);
    _dataList.push(d);
    return d;
}
exports.register = register;
function find(type) {
    return imports_1.l.find(_dataList, function (c) { return c.type === type; });
}
exports.find = find;
// export function tryFindByCode(code: string) {
//   return l.find(_dataList, (c) => code.startsWith(c.code)) || null
// }
function registerAll() {
    var _a, _b;
    var defaultMeleeWeapon = function () {
        return diveCrew_weaponData_sidecar_1.diveCrew_weaponData.createData({
            damage: 25,
            reloadTime: 5,
            preAttack1Time: 4,
            preAttack2Time: 4,
            postAttackTime: 4,
            maxDistance: 1.5,
            speed: 300,
            color: voyageColors_sidecar_1.voyageColors.red,
            type: diveEnums_1.EMessageBulletTeamType.Crew,
            bulletType: diveEnums_1.EDiveBulletSubtype.MeleeSlash,
            hitEffect: diveSlashEffect_1.EDiveSlashEffect.Slash,
            damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.Slash,
            bulletFrame: 'none',
        });
    };
    // register({
    //   type: TDiveEnemyType.Null,
    //   frames: [],
    //   name: 'Null',
    // })
    register({
        type: 'goblin-warrior',
        name: 'Goblin Warrior',
        frames: {
            idle: [sprites_sidecar_1.sprites.diveMonsters10C8[0], sprites_sidecar_1.sprites.diveMonsters11C9[0]],
            dead: [sprites_sidecar_1.sprites.diveMonsters12C10[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsGobwarAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsGobwarAtkR2Png[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Zombie,
            state: enumsAi_1.EAiState.Wander,
        },
        maxHitpoints: 100,
    });
    register({
        type: 'slime',
        name: 'Slime',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsSlimeIdleR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsSlimeIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveMonsters2WeeMonsSlimeDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsSlimeAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsSlimeAtkR2Png[0],
            ],
        },
        splatterTint: diveColors_1.diveColors.green,
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Zombie,
            state: enumsAi_1.EAiState.Wander,
        },
        moveTime: 7,
        maxHitpoints: 75,
        renderShadow: 3,
        resistances: (_a = {}, _a[voyageMessageCrewHurt_1.EVoyageCrewDamageType.Slash] = 1, _a),
        onHitEffect: enumsAi_1.EDiveOnHitEffect.SlashSplit,
    });
    register({
        type: 'rat',
        name: 'Rat',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsRatIdleR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsRatIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveMonsters2WeeMonsRatDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsRatAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters2WeeMonsRatAtkR2Png[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Zombie,
            state: enumsAi_1.EAiState.Wander,
        },
        moveTime: 4,
        maxHitpoints: 25,
        renderShadow: 3,
    });
    register({
        type: 'zombie',
        name: 'Zombie',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsZombieIdleR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsZombieIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveMonsters3WeeMonsZombieDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsZombieAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsZombieAtkR2Png[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Zombie,
            state: enumsAi_1.EAiState.Wander,
        },
        moveTime: 10,
        maxHitpoints: 50,
    });
    register({
        type: 'necromancer',
        name: 'Necromancer',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelmageIdleR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelmageIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelmageDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelmageAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelmageAtkR2Png[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Zombie,
            state: enumsAi_1.EAiState.Wander,
        },
        maxHitpoints: 100,
        moveTime: 10,
        renderShadow: 1,
        splatterTint: diveColors_1.diveColors.pureWhite,
        splatterType: diveEnums_1.EDiveSplatterType.Bone,
    });
    register({
        type: 'skeleton-warrior',
        name: 'Skeleton Warrior',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelshieldIdleR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelshieldIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelshieldDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelshieldAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters3WeeMonsSkelshieldAtkR2Png[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Zombie,
            state: enumsAi_1.EAiState.Wander,
        },
        maxHitpoints: 200,
        moveTime: 10,
        renderShadow: 1,
        splatterTint: diveColors_1.diveColors.pureWhite,
        splatterType: diveEnums_1.EDiveSplatterType.Bone,
        resistances: (_b = {}, _b[voyageMessageCrewHurt_1.EVoyageCrewDamageType.Pierce] = 0.8, _b),
    });
    // TODO: add skills
    register({
        type: 'spider-queen',
        name: 'Spider Queen',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderIdleR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderAtkR2Png[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Spider,
            state: enumsAi_1.EAiState.Wander,
        },
        maxHitpoints: 1500,
        moveTime: 10,
        renderShadow: 1,
        splatterTint: diveColors_1.diveColors.red,
        splatterType: diveEnums_1.EDiveSplatterType.Blood,
        scale: 1.0,
        abilities: [enumsAi_1.EAiAbility.SpawnSpiderEgg],
        maxAbilityTicksTime: 5 * 10,
    });
    register({
        type: 'spider-large',
        name: 'Large Spider',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderIdleR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderAtkR2Png[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Spider,
            state: enumsAi_1.EAiState.Wander,
        },
        maxHitpoints: 100,
        moveTime: 6,
        renderShadow: 1,
        splatterTint: diveColors_1.diveColors.red,
        splatterType: diveEnums_1.EDiveSplatterType.Blood,
        scale: 0.66,
        abilities: [enumsAi_1.EAiAbility.SpawnSpiderWeb],
        maxAbilityTicksTime: 10 * 10,
    });
    register({
        type: 'spider-mini',
        name: 'Baby Spider',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderIdleR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderAtkR1Png[0],
                sprites_sidecar_1.sprites.diveMonsters4WeeMonsSpiderAtkR2Png[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Spider,
            state: enumsAi_1.EAiState.FleeBasic, // TODO: flee
        },
        maxHitpoints: 25,
        moveTime: 4,
        renderShadow: 1,
        splatterTint: diveColors_1.diveColors.red,
        splatterType: diveEnums_1.EDiveSplatterType.Blood,
        scale: 0.33,
        transformInto: 'spider-large',
        transformTicksTime: 15 * 10,
    });
    register({
        type: 'golem',
        name: 'Golem',
        letter: 'G',
        frames: {
            idle: [sprites_sidecar_1.sprites.wargamesProtoSquare[0], sprites_sidecar_1.sprites.wargamesProtoSquare[0]],
            dead: [sprites_sidecar_1.sprites.wargamesProtoGriddedSpace[0]],
            attackR: [
                sprites_sidecar_1.sprites.wargamesProtoSquare[0],
                sprites_sidecar_1.sprites.wargamesProtoSquare[0],
            ],
        },
        weaponData: defaultMeleeWeapon(),
        initialAi: {
            mode: enumsAi_1.EAiMode.Zombie,
            state: enumsAi_1.EAiState.Wander,
        },
        maxHitpoints: 5000,
        moveTime: 10,
        renderShadow: 1,
        splatterTint: diveColors_1.diveColors.gray,
        splatterType: diveEnums_1.EDiveSplatterType.Blood,
        scale: 1,
    });
}
exports.registerAll = registerAll;
